export default "__VITE_ASSET__DAUd6B3O__"